import React from 'react';
import BrandDetail from '../components/BrandDetail';

const Modernist = () => {
  return <BrandDetail brandSlug="modernist" />;
};

export default Modernist;
